import afZA from './af-ZA.json';
import amET from './am-ET.json';
import arAE from './ar-AE.json';
import arEG from './ar-EG.json';
import arSA from './ar-SA.json';
import bgBG from './bg-BG.json';
import bnIN from './bn-IN.json';
import csCZ from './cs-CZ.json';
import deDE from './de-DE.json';
import enAE from './en-AE.json';
import enAU from './en-AU.json';
import enCA from './en-CA.json';
import enEG from './en-EG.json';
import enGB from './en-GB.json';
import enIN from './en-IN.json';
import enSA from './en-SA.json';
import enSG from './en-SG.json';
import enUS from './en-US.json';
import esAR from './es-AR.json';
import esCL from './es-CL.json';
import esCO from './es-CO.json';
import esES from './es-ES.json';
import esMX from './es-MX.json';
import esUS from './es-US.json';
import faAF from './fa-AF.json';
import frCA from './fr-CA.json';
import frFR from './fr-FR.json';
import guIN from './gu-IN.json';
import haNG from './ha-NG.json';
import heIL from './he-IL.json';
import hiIN from './hi-IN.json';
import htHT from './ht-HT.json';
import huHU from './hu-HU.json';
import idID from './id-ID.json';
import igNG from './ig-NG.json';
import itIT from './it-IT.json';
import jaJP from './ja-JP.json';
import knIN from './kn-IN.json';
import koKR from './ko-KR.json';
import ltLT from './lt-LT.json';
import lvLV from './lv-LV.json';
import mlIN from './ml-IN.json';
import mrIN from './mr-IN.json';
import myMM from './my-MM.json';
import neNP from './ne-NP.json';
import nlNL from './nl-NL.json';
import paIN from './pa-IN.json';
import plPL from './pl-PL.json';
import psAF from './ps-AF.json';
import ptBR from './pt-BR.json';
import ptPT from './pt-PT.json';
import roRO from './ro-RO.json';
import ruRU from './ru-RU.json';
import rwRW from './rw-RW.json';
import skSK from './sk-SK.json';
import slSI from './sl-SI.json';
import soSO from './so-SO.json';
import svSE from './sv-SE.json';
import swKE from './sw-KE.json';
import taIN from './ta-IN.json';
import teIN from './te-IN.json';
import tiER from './ti-ER.json';
import tlPH from './tl-PH.json';
import trTR from './tr-TR.json';
import ukUA from './uk-UA.json';
import urPK from './ur-PK.json';
import viVN from './vi-VN.json';
import xhZA from './xh-ZA.json';
import yoNG from './yo-NG.json';
import zhCN from './zh-CN.json';
import zhTW from './zh-TW.json';
import zuZA from './zu-ZA.json';

const loadLocale = (i18next) => {
    i18next.addResources('af-ZA', 'translation', afZA);
    i18next.addResources('am-ET', 'translation', amET);
    i18next.addResources('ar-AE', 'translation', arAE);
    i18next.addResources('ar-EG', 'translation', arEG);
    i18next.addResources('ar-SA', 'translation', arSA);
    i18next.addResources('bg-BG', 'translation', bgBG);
    i18next.addResources('bn-IN', 'translation', bnIN);
    i18next.addResources('cs-CZ', 'translation', csCZ);
    i18next.addResources('de-DE', 'translation', deDE);
    i18next.addResources('en-AE', 'translation', enAE);
    i18next.addResources('en-AU', 'translation', enAU);
    i18next.addResources('en-CA', 'translation', enCA);
    i18next.addResources('en-EG', 'translation', enEG);
    i18next.addResources('en-GB', 'translation', enGB);
    i18next.addResources('en-IN', 'translation', enIN);
    i18next.addResources('en-SA', 'translation', enSA);
    i18next.addResources('en-SG', 'translation', enSG);
    i18next.addResources('en-US', 'translation', enUS);
    i18next.addResources('es-AR', 'translation', esAR);
    i18next.addResources('es-CL', 'translation', esCL);
    i18next.addResources('es-CO', 'translation', esCO);
    i18next.addResources('es-ES', 'translation', esES);
    i18next.addResources('es-MX', 'translation', esMX);
    i18next.addResources('es-US', 'translation', esUS);
    i18next.addResources('fa-AF', 'translation', faAF);
    i18next.addResources('fr-CA', 'translation', frCA);
    i18next.addResources('fr-FR', 'translation', frFR);
    i18next.addResources('gu-IN', 'translation', guIN);
    i18next.addResources('ha-NG', 'translation', haNG);
    i18next.addResources('he-IL', 'translation', heIL);
    i18next.addResources('hi-IN', 'translation', hiIN);
    i18next.addResources('ht-HT', 'translation', htHT);
    i18next.addResources('hu-HU', 'translation', huHU);
    i18next.addResources('id-ID', 'translation', idID);
    i18next.addResources('ig-NG', 'translation', igNG);
    i18next.addResources('it-IT', 'translation', itIT);
    i18next.addResources('ja-JP', 'translation', jaJP);
    i18next.addResources('kn-IN', 'translation', knIN);
    i18next.addResources('ko-KR', 'translation', koKR);
    i18next.addResources('lt-LT', 'translation', ltLT);
    i18next.addResources('lv-LV', 'translation', lvLV);
    i18next.addResources('ml-IN', 'translation', mlIN);
    i18next.addResources('mr-IN', 'translation', mrIN);
    i18next.addResources('my-MM', 'translation', myMM);
    i18next.addResources('ne-NP', 'translation', neNP);
    i18next.addResources('nl-NL', 'translation', nlNL);
    i18next.addResources('pa-IN', 'translation', paIN);
    i18next.addResources('pl-PL', 'translation', plPL);
    i18next.addResources('ps-AF', 'translation', psAF);
    i18next.addResources('pt-BR', 'translation', ptBR);
    i18next.addResources('pt-PT', 'translation', ptPT);
    i18next.addResources('ro-RO', 'translation', roRO);
    i18next.addResources('ru-RU', 'translation', ruRU);
    i18next.addResources('rw-RW', 'translation', rwRW);
    i18next.addResources('sk-SK', 'translation', skSK);
    i18next.addResources('sl-SI', 'translation', slSI);
    i18next.addResources('so-SO', 'translation', soSO);
    i18next.addResources('sv-SE', 'translation', svSE);
    i18next.addResources('sw-KE', 'translation', swKE);
    i18next.addResources('ta-IN', 'translation', taIN);
    i18next.addResources('te-IN', 'translation', teIN);
    i18next.addResources('ti-ER', 'translation', tiER);
    i18next.addResources('tl-PH', 'translation', tlPH);
    i18next.addResources('tr-TR', 'translation', trTR);
    i18next.addResources('uk-UA', 'translation', ukUA);
    i18next.addResources('ur-PK', 'translation', urPK);
    i18next.addResources('vi-VN', 'translation', viVN);
    i18next.addResources('xh-ZA', 'translation', xhZA);
    i18next.addResources('yo-NG', 'translation', yoNG);
    i18next.addResources('zh-CN', 'translation', zhCN);
    i18next.addResources('zh-TW', 'translation', zhTW);
    i18next.addResources('zu-ZA', 'translation', zuZA);
};

export default loadLocale;
